module.exports = __webpack_public_path__ + "assets/4dc38e461056576d3c55bfa9610c80d8.mp3";